import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";

//Forms
import UpdateBillingDetailsForm from "./UpdateBillingDetailsForm";

interface ModalProps {
  company_code: string;
  company_name: string;
  modal: boolean;
  toggle?: () => void;
}

const UpdateBillingModal: React.FC<ModalProps> = ({
  company_code,
  company_name,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Billing Address</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>
          <UpdateBillingDetailsForm
            toggle={toggle}
            company_code={company_code}
            company_name={company_code}
          />
        </div>
      </Modal>
    </>
  );
};
export default UpdateBillingModal;
